import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@unico-people/shared/utils/environments';

import { AuthService } from '@unico-people/shared/dashboard/data-access-auth';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { DataAccessCompanyInfosService } from '@unico-people/shared/data-access/data-access-company-infos';
import { WarningDialogComponent } from '../../../../../ongoing/src/lib/components/warning-dialog/warning-dialog.component';
import * as Sentry from '@sentry/angular-ivy';
import { getCsrfToken, getTokenStorage, SessionStorage, setCsrfToken } from '@unico-people/shared/utils/storage';

declare const userGuiding;

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  public currentAccount: string;
  public currentOrganization: string;
  private activatedRoute: ActivatedRoute

  dialogCollaborator: MatDialogRef<WarningDialogComponent>;

  constructor(private authService: AuthService, private router: Router, private companyInfosService: DataAccessCompanyInfosService, public dialog: MatDialog, private location: Location,) {

    this.companyInfosService.companyInfos$.subscribe((res) => {
      this.currentOrganization = res?.organizationId;
      this.currentAccount = res?.accountId;
    })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isProductionSendUserIdentity();
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = getTokenStorage();
    const csrfToken = getCsrfToken();
    const currentAccount = SessionStorage.getItem('currentAccount');
    const currentOrganization = SessionStorage.getItem('organization');
    const isBenefitsApi = environment?.url_benefits_api;
    const isCollaboratorsApi = environment?.url_ongoing_api;
    const isRoutingApi = environment?.url_routing_api;

    if (
      !request.url.includes('/authorize') &&
      !request.url.includes(isBenefitsApi) &&
      !request.url.includes('googleapis') &&
      !request.url.includes('/employee/invite') &&
      !request.url.includes('/authorize/code')
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
        withCredentials: true
      });
    }

    if (request.url.includes(isBenefitsApi) || (request.url.includes(isRoutingApi) && !request.url.includes('/authorize/code'))) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Acesso-Account-Id': currentAccount,
          'Acesso-Org-Id': currentOrganization
        },
        withCredentials: true
      });
    }

    if (!request.url.includes('/authorize/code') && request.method !== 'GET' && csrfToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Acesso-Csrf-Token': csrfToken
        },
        withCredentials: true
      });
    }

    if (!request.url.includes('/authorize/code') && request.url.includes(isCollaboratorsApi + '/employees') || request.url.includes(isCollaboratorsApi + '/file-import') || request.url.includes(isCollaboratorsApi + '/change-benefits') || request.url.includes(isCollaboratorsApi + '/skills')) {
      request = request.clone({
        setHeaders: {
           accountId: currentAccount,
        },
      });
    }

    return next.handle(request).pipe(
      map(res => {
        if (res instanceof HttpResponse && res?.headers?.keys().includes('acesso-csrf-token')) {
          const csrf_token = res?.headers.get('acesso-csrf-token');
          setCsrfToken(csrf_token);
        }
        return res;
      }),
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (this.isStatusCode4xx(err.status) && err.status !== 401 ) {
            Sentry.captureException(err);
          }
          if (err.status === 401) {
            this.authService.logout(this.activatedRoute?.snapshot?.data?.roles);
          }
          if (err.status === 403 && !request.url.includes('/flags/evaluate')) {
            this.dialogCollaborator = this.dialog.open(WarningDialogComponent, {
              disableClose: false
            });
            this.dialogCollaborator.afterClosed().subscribe(() => this.location.back());
          }
        }
        return throwError(err);
      })
    );
  }

  isProductionSendUserIdentity(): void {
    const infos = SessionStorage.getItem('user');
    const organizationName = SessionStorage.getItem('organizationName');

    if (environment?.production && infos) {
      userGuiding.identify(infos.user_id, {
        email: infos.user_email,
        Organization: organizationName,
        Product: 'unico | people',
        User: 'RH'
      });
    }
  }

  isStatusCode4xx (statusCode: number): boolean {
    const regexStatusCode4xx = /4[0-9][0-9]/g;
    return regexStatusCode4xx.test(statusCode.toString());
  }
}
